module.exports = __webpack_public_path__ + "img/icon_directions3.8c503d0a.png";